var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"indexContent",staticClass:"home-container",style:({ height: _vm.$store.state.themeInfo.type === 1 ? '100%' : '', overflowX: 'hidden' })},[(_vm.$store.state.themeInfo.type === 2)?[_c('head-menu'),_c('live-content'),_c('news-content'),_c('video-content')]:(_vm.$store.state.themeInfo.type === 1)?[_c('head-menu')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }